//React Imports
import React, { useEffect, useMemo, useState } from 'react';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { NumericFormat } from 'react-number-format';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import Collapse from 'react-bootstrap/Collapse';
import DatePicker from "react-datepicker";
import moment from 'moment';
import { MdChat } from 'react-icons/md';

//Components
import TooltipComponent from '../TooltipComponent';
import TooltipAlertComponent from '../TooltipAlertComponent';
import GetTypeInput from '../FormInput/set';
import FormInput from '../FormInput/index';
import { CommentTextArea, Field, IconNewDiscussion } from './styles';
import ChatButton from '../ChatButton/index';

//Style
import { FaTrashAlt } from 'react-icons/fa';
import {
    applyRule,
    findAnswerForDynamicBlock,
    getRefAnswersForSelectionFromKpi,
    getValToCheckFromStoredAnswer,
    parseListTreeItemIdsFromTextValue,
    parseFilterListTreeRefNumber,
    refNumbersLooseEqual,
    computeRowModeValueColumnWidths,
    getRowModeValueTdWidthStyle,
    isWideRowModeValueColumn,
} from '../../services/functions';
import SelectionFromKpiSelectField from '../SelectionFromKpiSelectField';

const RowSimpleGrouped = ({
    calculations, sskList, descriptionFragments, subSectionGroupColumnInfo, moduleObject, setModuleObject, toleranceValidations, setNumber, setText, funcCollapse, collapse, collapseText, defaultChatRequest,
    setComment, uploadFile, getFile, numberOfColumns, userRoles, showDescriptionColumn, collapseRow,
    showUnitColumn, showSecondaryUnitsColumn, numberOfRows, row, blockedField, addNewLine,
    removeLastLine, hasAddandRemoveButtons, MODULE_ID, setChatRequest, setShowChat, chatRequest,
    kpiDiscussions, cultureTypeID = null, subSectionKPIsToBlock, loading, kpi, subSectionKPIs, setSelectedSSK, changeSelectedCultureType, selectedCultureTypes, changeSelectedCountry, selectedCountries,
    changeSelectedFuelType, selectedFuelTypes, selectedCultureTypesRow, changeSelectedCultureTypeRow, columnRows, reordenateColumns, loadRefNumbersAndCalculations, rejectedKpisList, fixedKpisList, selectedCuringBarns, changeSelectedCuringBarn, valueColumnsWidth, valueCellMinWidthPx = 240
}) => {
    const [userObject, setUserObject] = useState(JSON.parse(localStorage.getItem('@Thrive:user')));

    const rowValueColumnLayout = useMemo(
        () =>
            computeRowModeValueColumnWidths(
                kpi,
                subSectionKPIs,
                columnRows,
                reordenateColumns,
                valueColumnsWidth,
                70,
            ),
        [kpi, subSectionKPIs, columnRows, valueColumnsWidth, reordenateColumns],
    );

    const collapseByRow = (ssk, name) => {
        funcCollapse(ssk.subSectionKPIID, name, row, null);
        setSelectedSSK(ssk);
    }


    const formatValuesInTooltip = (value, decimalSeparator, decimalScale, suffix, isEditable, isCalculation, isHighlight, isHighLightBorderColor, borderColor) => {
        const dSep = decimalSeparator && String(decimalSeparator).length > 0 ? decimalSeparator : '.';
        const dScale = Number.isInteger(decimalScale) ? decimalScale : 0;
        const dSuffix = suffix || '';
        const borderStyle = {
            border: isHighLightBorderColor && value ? `2px solid ${borderColor}` : 'none'
        };
        return (
            isCalculation || (value != null && typeof (value) == "number") ?
                <NumericFormat
                    value={value}
                    thousandsGroupStyle="thousand"
                    {...(dScale > 0 ? { decimalSeparator: dSep } : {})}
                    decimalScale={dScale}
                    suffix={dSuffix}
                    style={isHighlight ? { border: "2px solid #FBBA00" } : isHighLightBorderColor ? { border: `2px solid ${borderColor}` } : {}}
                    displayType="input"
                    type="text"
                    valueIsNumericString={true}
                    readOnly={!isEditable}
                    className={!isEditable && isCalculation ? "read-only-total" : "read-only"}
                    thousandSeparator={true}
                    allowNegative={true}
                    allowLeadingZeros={false}
                    placeholder="00.00"
                />
                :
                <>
                    <input type='text' style={borderStyle} value={value || ''} />
                </>
        )
    }

    const IconDiscussionToAnswer = (kpiDiscussion) => {
        if (kpiDiscussion != null) {
            if (kpiDiscussion.messages != null && kpiDiscussion.messages != undefined) {
                if (kpiDiscussion.messages.length > 0) {
                    if (kpiDiscussion.messages[kpiDiscussion.messages.length - 1].createdBy != userObject.id) {
                        if (kpiDiscussion.lastDiscussionStatus == "Open")
                            return (<IconNewDiscussion className='icon-newdiscussion'></IconNewDiscussion>)
                    }
                }
            }
        }
    }

    const formatValuesInTooltipNumber = (value, decimalSeparator, decimalScale, suffix, isCalculation, isHighLightBorderColor, borderColor) => {
        const dSep = decimalSeparator && String(decimalSeparator).length > 0 ? decimalSeparator : '.';
        const dScale = Number.isInteger(decimalScale) ? decimalScale : 0;
        const dSuffix = suffix || '';
        const borderStyle = {
            border: isHighLightBorderColor && value ? `2px solid ${borderColor}` : 'none'
        };
        return (
            isCalculation || (value != null && typeof (value) == "number") ?
                <NumericFormat
                    value={value}
                    thousandsGroupStyle="thousand"
                    {...(dScale > 0 ? { decimalSeparator: dSep } : {})}
                    decimalScale={dScale}
                    suffix={dSuffix}
                    displayType="text"
                    type="text"
                    valueIsNumericString={true}
                    thousandSeparator={true}
                    allowNegative={true}
                    allowLeadingZeros={false}
                />
                :
                <>
                    <input type='text' style={borderStyle} value={value || ''} readOnly />
                </>
        )
    }

    const tooltipShowsStoredValue = v =>
        v != null &&
        !(typeof v === 'number' && Number.isNaN(v)) &&
        (typeof v !== 'string' || v.trim() !== '');

    return <>
        {
            reordenateColumns(columnRows).filter(x => x.isParentColumn == false).map((columnRow, i) => {
                var sskpi = kpi.subSectionKPIs.find(x => x.columnRowID == columnRow.columnRowID);
                if (sskpi) {
                    var unitMeasure = GetTypeInput(sskpi.unitMeasureID, sskpi.unitMeasure.type);
                    var isNumber = (sskpi.unitMeasure.inputType == "number" || sskpi.unitMeasure.inputType == "decimal") ? true : false;
                    var calculation = sskpi.inputCalc == "Calculation" || sskpi.inputCalc == "DisplayText" ? sskpi.calculation : null;
                    var isCalculation = false;
                    var isDisplayText = false;
                    var alertMessage = sskpi.alertMessage;

                    var op = `subSectionKPI_${sskpi.subSectionKPIID}_${sskpi.columnRowID}_r${row}`


                    if (calculation != null && sskpi.inputCalc == "Calculation") {
                        isCalculation = true;
                    }

                    if (calculation != null && sskpi.inputCalc == "DisplayText") {
                        isDisplayText = true;
                    }


                    var findValue = null;
                    var file = undefined;
                    var comment = "";
                    var value = null;
                    var country = null;
                    var disabledField = false;
                    var isFromFSMIntegration = null;
                    var highlightField = false;
                    var highLightBorderColor = false;

                    if (numberOfRows > 1) {
                        findValue = moduleObject.answers.find(x => x.subSectionKPIID == sskpi.subSectionKPIID && x.refNumber == sskpi.refNumber && x.row == row && x.subSectionID == sskpi.subSectionID);
                    } else {
                        findValue = moduleObject.answers.find(x => x.subSectionKPIID == sskpi.subSectionKPIID && x.refNumber == sskpi.refNumber);
                    }

                    if (findValue != undefined && findValue != null) {
                        value = isNumber ? findValue.numberValue : getValToCheckFromStoredAnswer(findValue);
                        file = findValue.file;
                        comment = findValue.comment;
                        isFromFSMIntegration = findValue.isFromFSMIntegration;
                    }
                    var hasDiscussion = kpiDiscussions.find(x => x.subSectionKPIID == sskpi.subSectionKPIID && x.row == row);
                    var discussionCollor = "";
                    if (hasDiscussion) {
                        if ((hasDiscussion?.column != null || hasDiscussion?.row != null)) {
                            if ((hasDiscussion?.column != null ? hasDiscussion?.column == null : true) && (hasDiscussion?.row != null ? hasDiscussion?.row == row : true)) {
                                discussionCollor = hasDiscussion.lastDiscussionStatus == "Open" ? "#FFDA7E" : hasDiscussion.lastDiscussionStatus == "Closed" ? "#ABF0B0" : "";
                            } else {
                                hasDiscussion = null;
                            }
                        } else {
                            discussionCollor = hasDiscussion.lastDiscussionStatus == "Open" ? "#FFDA7E" : hasDiscussion.lastDiscussionStatus == "Closed" ? "#ABF0B0" : "";
                        }
                    }

                    const blockedFromServerList = !!(
                        subSectionKPIsToBlock?.some(x => x.refNumber == sskpi.refNumber && x.row == row)
                    );
                    const isVictimOfDynamicRule =
                        moduleObject.dynamicBlockKpis &&
                        Object.keys(moduleObject.dynamicBlockKpis).length > 0 &&
                        Object.values(moduleObject.dynamicBlockKpis).some(blocks =>
                            Array.isArray(blocks) &&
                            blocks.some(b =>
                                (b.refNumbersToBlock || []).some(refToBlock => refToBlock == sskpi.refNumber),
                            ),
                        );

                    let forceDisabledByConditional = false;
                    if (moduleObject.dynamicBlockKpis) {
                        Object.entries(moduleObject.dynamicBlockKpis || {}).forEach(([key, blocks]) => {
                            const blocksThatTargetThisField = blocks.filter(block =>
                                (block.refNumbersToBlock || []).some(refToBlock => refToBlock == sskpi.refNumber),
                            );
                            if (!blocksThatTargetThisField.length) return;

                            const blockTargetAnswer = findAnswerForDynamicBlock(moduleObject, key, row, null);
                            const targetValue = getValToCheckFromStoredAnswer(blockTargetAnswer);

                            blocksThatTargetThisField.forEach(block => {
                                if (block.answerToBlock == "null") {
                                    if (targetValue == null) forceDisabledByConditional = true;
                                } else if (targetValue != null && applyRule(targetValue, block.answerToBlock)) {
                                    forceDisabledByConditional = true;
                                }
                            });
                        });
                    }

                    const conditionalBlocked = isVictimOfDynamicRule
                        ? forceDisabledByConditional
                        : blockedFromServerList || forceDisabledByConditional;

                    if (columnRow.type == 4) {
                        if (sskpi.unitMeasure.type === "selectculture" && !moduleObject.isEditable) {
                            value = moduleObject.cultureTypesOptions?.find(x => x.value == value)?.text;
                        }
                    }

                    if (columnRow.type == 2) {
                        const selectedCountry = selectedCountries?.find(
                            e => e.index == row && e.subSectionID == sskpi.subSectionID
                        );
                        if (
                            (selectedCountry == null || selectedCountry.text == "") &&
                            sskpi.unitMeasure.type != "selectcountry"
                        ) {
                            disabledField = true
                        } else {
                            disabledField = conditionalBlocked
                        }
                        if (columnRow.kpiReference == sskpi.refNumber && !moduleObject.isEditable) {
                            let auxVal = value;
                            value = selectedCountries[row]?.text;
                            if (value == "" || value == null) {
                                var arrayCountry = [...selectedCountries];
                                var countrie = arrayCountry?.find(x => x.value == auxVal);
                                if (countrie != null) {
                                    value = countrie?.text;
                                }

                            }
                        }
                    }
                    else if (columnRow.type == 3) {
                        if ((((selectedFuelTypes?.filter(x => x.index == row && x.subSectionID == sskpi.subSectionID)[0] == null) || (selectedFuelTypes.filter(x => x.index == row && x.subSectionID == sskpi.subSectionID)[0]?.text == "")) && sskpi.unitMeasure.type != "selectfuel") || (rejectedKpisList != null && rejectedKpisList?.length > 0)) {
                            disabledField = true
                        } else {
                            disabledField = conditionalBlocked
                        }

                        if (columnRow.kpiReference == sskpi.refNumber && !moduleObject.isEditable) {
                            value = selectedFuelTypes?.find(x => x.value == value)?.text;
                            if (value == null || value == "") {
                                value = selectedFuelTypes?.find(x => x.index == row && x.subSectionID == sskpi.subSectionID)?.text;
                            }

                        }
                        else if (sskpi.unitMeasure.type === "fuelTypeUnit") {
                            value = selectedFuelTypes?.find(x => x.index == row && x.subSectionID == sskpi.subSectionID)?.unit;
                        }
                        else if (sskpi.unitMeasure.type === "selectCuringBarn" && !moduleObject.isEditable) {
                            value = selectedCuringBarns?.find(x => x.index == row && x.subSectionID == sskpi.subSectionID)?.text;
                        }
                        else if (sskpi.unitMeasure.type === "selectculture" && !moduleObject.isEditable) {
                            value = moduleObject.cultureTypesOptions?.find(x => x.value == value)?.text;
                        }
                    }

                    if (conditionalBlocked) {
                        disabledField = true;
                    }

                    if (isDisplayText) {
                        disabledField = true;
                    } else if (
                        isCalculation &&
                        !parseFilterListTreeRefNumber(sskpi.calculation)
                    ) {
                        disabledField = true;
                    }
                    
                    //TODO - Set diasbledField based on reject Partial status
                    if (rejectedKpisList != null && rejectedKpisList?.length > 0) {
                        disabledField = true
                    }

                    if (rejectedKpisList?.some(x => x.subSectionKPIID == sskpi.subSectionKPIID && x.rowIndex == row)) {
                        disabledField = false
                    }

                    // O bloqueio condicional prevalece sobre a reabertura parcial (mesma ordem do ColumnSimpleGrouped)
                    if (conditionalBlocked) {
                        disabledField = true
                    }

                    if (rejectedKpisList?.some(x => x.subSectionKPIID == sskpi.subSectionKPIID && x.rowIndex == row) && userRoles.includes("RoleApprover")) {
                        highlightField = true;
                        highLightBorderColor = true;
                    }

                    var userObj = JSON.parse(localStorage.getItem('@Thrive:user'));
                    var isApproving = false;
                    //Validate if user is local approver or global
                    if ((moduleObject?.version?.status == 2 && userObj?.companyID != null && userRoles.includes("RoleApprover")) || (moduleObject?.version?.status == 4 && userObj?.companyID == null && userRoles.includes("RoleApprover"))) {
                        isApproving = true;
                    }

                    if (fixedKpisList?.some(x => x.subSectionKPIID == sskpi.subSectionKPIID && x.rowIndex == row) && !moduleObject.isEditable && isApproving) {
                        highlightField = true;
                        highLightBorderColor = true;
                    }

                    if (sskpi.borderColor) {
                        highLightBorderColor = true;
                    }

                    let shouldShowBlockedAlert = false;
                    if (conditionalBlocked && disabledField) {
                        let hasValueForBlockedAlert = false;
                        if (findValue != null) {
                            const valFromFind = isNumber
                                ? findValue.numberValue
                                : getValToCheckFromStoredAnswer(findValue);
                            hasValueForBlockedAlert =
                                valFromFind != null && valFromFind !== '';
                        }
                        if (!hasValueForBlockedAlert && value != null && value !== '') {
                            hasValueForBlockedAlert = true;
                        }
                        if (hasValueForBlockedAlert) {
                            shouldShowBlockedAlert = true;
                        }
                    }

                    var SSKReferenceAnswersOptionsList = [];
                    if (sskpi.unitMeasure.type === 'Selection from kpi' && sskpi.selectAnswersRefNumber) {
                        const refSubSectionKPIForOptions = subSectionKPIs.find(x => x.refNumber === sskpi.selectAnswersRefNumber);
                        const isListTreeSelectRef = refSubSectionKPIForOptions?.unitMeasure?.description === 'ListTreeSelect';
                        const effectiveListTreeId = refSubSectionKPIForOptions?.listTreeID ?? sskpi.listTreeID;
                        if (refSubSectionKPIForOptions && !isListTreeSelectRef && !effectiveListTreeId) {
                            const refAnswers = getRefAnswersForSelectionFromKpi(
                                moduleObject,
                                sskpi.selectAnswersRefNumber,
                                refSubSectionKPIForOptions,
                                { numberOfRows, numberOfColumns, row, column: null },
                            );
                            const seen = new Set();
                            refAnswers.forEach(a => {
                                const raw = a.textValue != null && String(a.textValue).trim() !== ''
                                    ? String(a.textValue).trim()
                                    : (a.numberValue != null && a.numberValue !== '' ? String(a.numberValue) : null);
                                if (raw && !seen.has(raw)) {
                                    seen.add(raw);
                                    SSKReferenceAnswersOptionsList.push({ value: raw, text: raw });
                                }
                            });
                        } else if (refSubSectionKPIForOptions && isListTreeSelectRef && !effectiveListTreeId) {
                            const refAnswers = getRefAnswersForSelectionFromKpi(
                                moduleObject,
                                sskpi.selectAnswersRefNumber,
                                refSubSectionKPIForOptions,
                                { numberOfRows, numberOfColumns, row, column: null },
                            );
                            const seen = new Set();
                            refAnswers.forEach(a => {
                                parseListTreeItemIdsFromTextValue(a.textValue).forEach(id => {
                                    const key = String(id);
                                    if (!seen.has(key)) {
                                        seen.add(key);
                                        SSKReferenceAnswersOptionsList.push({ value: key, text: key });
                                    }
                                });
                            });
                        }
                    }

                    const filterRefNumber =
                        sskpi.inputCalc === 'Calculation'
                            ? parseFilterListTreeRefNumber(sskpi.calculation)
                            : null;
                    const filterSourceSsk = filterRefNumber
                        ? subSectionKPIs.find(x =>
                              refNumbersLooseEqual(x.refNumber, filterRefNumber),
                          )
                        : null;
                    const parentItemIDsFilter = filterSourceSsk
                        ? (() => {
                              const refAnswers = getRefAnswersForSelectionFromKpi(
                                  moduleObject,
                                  filterRefNumber,
                                  filterSourceSsk,
                                  {
                                      numberOfRows,
                                      numberOfColumns,
                                      row,
                                      column: null,
                                  },
                              );
                              const ids = [];
                              const seen = new Set();
                              refAnswers.forEach(a =>
                                  parseListTreeItemIdsFromTextValue(a.textValue).forEach(id => {
                                      if (!seen.has(id)) {
                                          seen.add(id);
                                          ids.push(id);
                                      }
                                  }),
                              );
                              return ids;
                          })()
                        : null;

                    const isWideRowModeCell = isWideRowModeValueColumn(sskpi, subSectionKPIs);
                    const valueTdWidth = getRowModeValueTdWidthStyle(sskpi, subSectionKPIs, rowValueColumnLayout);

                    const valueCellMin = Math.max(
                        isWideRowModeCell ? 180 : 120,
                        valueCellMinWidthPx ?? 0,
                    );
                    return <>
                        <td 
                            key={`KPIColumnRow_td_${i}`} 
                            colSpan={1}
                            style={{
                                minWidth: `${valueCellMin}px`,
                                width: valueTdWidth,
                                maxWidth: isWideRowModeCell ? 'none' : undefined,
                            }}
                        >
                            <div className="row align-items-center" style={{ position: "relative" }}>
                                <div
                                    className={isWideRowModeCell ? 'col-11' : 'col-10'}
                                    style={{ padding: 0, minWidth: 0 }}
                                >
                                    {
                                        moduleObject.isEditable ?
                                            isNumber && !isCalculation ?
                                                <>
                                                    {loadRefNumbersAndCalculations(sskpi)}
                                                    {(sskpi.toleranceType) ? <TooltipAlertComponent id={`${op}_alert`} message={sskpi.alertMessage} className={`alert-column ${findValue?.toleranceInvalid ? '' : 'hide'}`} placement={"left"} /> : null}
                                                    <OverlayTrigger
                                                        delay={{ hide: 0, show: 100 }}
                                                        overlay={(props) => (
                                                            (value != null || sskpi.inputMessage != null) ? //validate overlay when field is text on Prompt Actions Modules
                                                                <Tooltip {...props}>
                                                                    {(tooltipShowsStoredValue(value) ? formatValuesInTooltipNumber(value, unitMeasure.decimalSeparator, unitMeasure.decimalPrecision, unitMeasure.suffix, isCalculation) : sskpi.inputMessage ? sskpi.inputMessage : "")}
                                                                </Tooltip>

                                                                :
                                                                <></>
                                                        )}
                                                        placement={"left"}>
                                                        <Field>
                                                            <NumericFormat
                                                                name={op}
                                                                id={op}
                                                                autoComplete="off"
                                                                className={`${findValue?.toleranceInvalid ? 'alert-input ' : ''}${shouldShowBlockedAlert ? 'alert-input-hasValue ' : ''}${kpi.description}`}
                                                                title={""}
                                                                thousandsGroupStyle="thousand"
                                                                value={value != null ? value : ""}
                                                                decimalSeparator={unitMeasure.decimalSeparator != "" ? unitMeasure.decimalSeparator : "."}
                                                                decimalScale={unitMeasure.decimalPrecision}
                                                                suffix={unitMeasure.suffix}
                                                                displayType="input"
                                                                type="text"
                                                                thousandSeparator={true}
                                                                allowNegative={true}
                                                                allowLeadingZeros={false}
                                                                allowEmptyFormatting={false}
                                                                placeholder="00.00"
                                                                disabled={disabledField}
                                                                style={highlightField ? { border: "2px solid #FBBA00" } : highLightBorderColor ? { border: `2px solid ${sskpi.borderColor}` } : {}}
                                                                onValueChange={(values, sourceInfo) => {
                                                                    setNumber({
                                                                        'subSectionKPI': sskpi,
                                                                        'ref': sskpi.refNumber,
                                                                        'value': (values.formattedValue != "" ? parseFloat(values.floatValue) : ""),
                                                                        'row': row,
                                                                        'moduleObject': moduleObject,
                                                                        'setModuleObject': setModuleObject,
                                                                        'subSectionKPIs': subSectionKPIs
                                                                    })
                                                                }}
                                                            />
                                                            {
                                                                sskpi.mandatory == true &&
                                                                <div class="required-icon">
                                                                    <div class="text">*</div>
                                                                </div>
                                                            }
                                                        </Field>
                                                    </OverlayTrigger>
                                                </>
                                                :
                                                isNumber && isCalculation ?
                                                    <>
                                                            {loadRefNumbersAndCalculations(sskpi)}
                                                            {(sskpi.toleranceType) ? <TooltipAlertComponent id={`${op}_alert`} message={sskpi.alertMessage} className={`alert-column ${findValue?.toleranceInvalid ? '' : 'hide'}`} placement={"left"} /> : null}
                                                            <OverlayTrigger
                                                                delay={{ hide: 0, show: 100 }}
                                                                overlay={(props) => (
                                                                    (value != null || sskpi.inputMessage != null) ? //validate overlay when field is text on Prompt Actions Modules
                                                                        <Tooltip {...props}>
                                                                            {(tooltipShowsStoredValue(value) ? formatValuesInTooltipNumber(value, unitMeasure.decimalSeparator, unitMeasure.decimalPrecision, unitMeasure.suffix, isCalculation) : (sskpi.inputMessage ? sskpi.inputMessage : ""))}
                                                                        </Tooltip>

                                                                        :
                                                                        <></>
                                                                )}
                                                                placement={"left"}>
                                                                <Field>
                                                                    <NumericFormat
                                                                        name={op}
                                                                        id={op}
                                                                        autoComplete="off"
                                                                        className={`${findValue?.toleranceInvalid ? 'alert-input ' : ''}read-only-total calculation`}
                                                                        disabled
                                                                        title={""}
                                                                        thousandsGroupStyle="thousand"
                                                                        value={value != null ? value : ""}
                                                                        decimalSeparator={unitMeasure.decimalSeparator != "" ? unitMeasure.decimalSeparator : "."}
                                                                        decimalScale={unitMeasure.decimalPrecision}
                                                                        suffix={value != null ? unitMeasure.suffix : ""}
                                                                        displayType="input"
                                                                        type="text"
                                                                        thousandSeparator={true}
                                                                        allowNegative={true}
                                                                        allowLeadingZeros={false}
                                                                        allowEmptyFormatting={true}
                                                                    />
                                                                    {
                                                                        sskpi.mandatory == true &&
                                                                        <div class="required-icon">
                                                                            <div class="text">*</div>
                                                                        </div>
                                                                    }
                                                                </Field>
                                                            </OverlayTrigger>
                                                        </>
                                                    :
                                                    sskpi.listTreeID && sskpi.optionsModeView > 0 ?
                                                        <>
                                                            {loadRefNumbersAndCalculations(sskpi)}
                                                            <Field>
                                                                <FormInput
                                                                    name={op}
                                                                    id={op}
                                                                    inputType="listtreeselect"
                                                                    listTreeID={sskpi.listTreeID}
                                                                    optionsModeView={sskpi.optionsModeView}
                                                                    allowSelectOnlyChildrenNodes={sskpi.allowSelectOnlyChildrenNodes}
                                                                    maxTreeDepth={sskpi.maxTreeDepth}
                                                                    parentItemIDsFilter={parentItemIDsFilter}
                                                                    value={value != null ? value : ''}
                                                                    disabled={disabledField}
                                                                    onChange={(v) => {
                                                                        const isMultiple = sskpi.optionsModeView === 2;
                                                                        const parsedID = !isMultiple && v ? (Number(v) || null) : null;
                                                                        setText({
                                                                            subSectionKPI: sskpi,
                                                                            ref: sskpi.refNumber,
                                                                            value: v,
                                                                            row,
                                                                            moduleObject,
                                                                            setModuleObject,
                                                                            subSectionKPIs,
                                                                            listTreeItemID: parsedID,
                                                                        });
                                                                    }}
                                                                />
                                                                {sskpi.mandatory == true &&
                                                                    <div class="required-icon">
                                                                        <div class="text">*</div>
                                                                    </div>
                                                                }
                                                            </Field>
                                                        </>
                                                    :
                                                    sskpi.unitMeasure.type === 'Selection from kpi' && sskpi.selectAnswersRefNumber ?
                                                        <SelectionFromKpiSelectField
                                                            sskpi={sskpi}
                                                            refSubSectionKPI={subSectionKPIs.find(x => x.refNumber === sskpi.selectAnswersRefNumber)}
                                                            fallbackOptions={SSKReferenceAnswersOptionsList}
                                                            numberOfRows={numberOfRows}
                                                            row={row}
                                                            numberOfColumns={1}
                                                            column={null}
                                                            moduleObject={moduleObject}
                                                            setModuleObject={setModuleObject}
                                                            op={op}
                                                            value={value}
                                                            disabledField={disabledField}
                                                            loading={loading}
                                                            setText={setText}
                                                            subSectionKPIs={subSectionKPIs}
                                                            findValue={findValue}
                                                            loadRefNumbersAndCalculations={loadRefNumbersAndCalculations}
                                                            cultureTypeID={cultureTypeID}
                                                            readOnly={false}
                                                        />
                                                    :
                                                    sskpi.unitMeasure.type === "selectfuel" ?
                                                        <>
                                                            {loadRefNumbersAndCalculations(sskpi)}
                                                            <TooltipAlertComponent id={`${op}_alert`} message={sskpi.alertMessage} className={`alert-column ${findValue?.toleranceInvalid ? '' : 'hide'}`} placement={"left"} />
                                                            <OverlayTrigger
                                                                delay={{ hide: 0, show: 100 }}
                                                                overlay={(props) => (
                                                                    (value != null || sskpi.inputMessage != null) ? //validate overlay when field is text on Prompt Actions Modules
                                                                        <Tooltip {...props}>
                                                                            {(value != null ? selectedFuelTypes.find(x => x.index == row && x.subSectionID == sskpi.subSectionID)?.text : (sskpi.inputMessage ? sskpi.inputMessage : ""))}
                                                                        </Tooltip>

                                                                        :
                                                                        <></>
                                                                )}
                                                                placement={"left"}>
                                                                <Field>
                                                                    {moduleObject.fuelTypesOptions.length > 0 &&
                                                                        <>
                                                                            <FormInput
                                                                                disabled={disabledField}
                                                                                className={findValue?.toleranceInvalid ? 'alert-input' : ''}
                                                                                blockedValueAlert={shouldShowBlockedAlert}
                                                                                options={moduleObject.fuelTypesOptions.filter(x => x.kpiRefNumber == sskpi.refNumber)}
                                                                                name={op}
                                                                                id={op}
                                                                                inputType={sskpi.unitMeasure.type}
                                                                                autoComplete="off"
                                                                                value={value != null ? value : ""}
                                                                                onChange={(f) => {
                                                                                    changeSelectedFuelType(f.target.value, sskpi, row, op)
                                                                                }}
                                                                            />
                                                                        </>

                                                                    }
                                                                    {
                                                                        sskpi.mandatory == true &&
                                                                        <div class="required-icon">
                                                                            <div class="text">*</div>
                                                                        </div>
                                                                    }
                                                                </Field>
                                                            </OverlayTrigger>
                                                        </>
                                                        :
                                                        sskpi.unitMeasure.type === "selectculture" ?
                                                            <>
                                                                {loadRefNumbersAndCalculations(sskpi)}
                                                                <TooltipAlertComponent id={`${op}_alert`} message={sskpi.alertMessage} className={`alert-column ${findValue?.toleranceInvalid ? '' : 'hide'}`} placement={"left"} />
                                                                <OverlayTrigger
                                                                    delay={{ hide: 0, show: 100 }}
                                                                    overlay={(props) => (
                                                                        (value != null || sskpi.inputMessage != null) ? //validate overlay when field is text on Prompt Actions Modules
                                                                            <Tooltip {...props}>
                                                                                {(value != null ? selectedCultureTypesRow.find(x => x.index == row && x.subSectionID == sskpi.subSectionID)?.text : (sskpi.inputMessage ? sskpi.inputMessage : ""))}
                                                                            </Tooltip>

                                                                            :
                                                                            <></>
                                                                    )}
                                                                    placement={"left"}>
                                                                    <Field>
                                                                        {moduleObject.cultureTypesOptions.length > 0 &&
                                                                            <>
                                                                                <FormInput
                                                                                    disabled={disabledField}
                                                                                    className={findValue?.toleranceInvalid ? 'alert-input' : ''}
                                                                                    blockedValueAlert={shouldShowBlockedAlert}
                                                                                    options={moduleObject.cultureTypesOptions.map(option => ({
                                                                                        ...option,
                                                                                        hidden: false
                                                                                    }))}
                                                                                    name={op}
                                                                                id={op}
                                                                                inputType={sskpi.unitMeasure.type}
                                                                                autoComplete="off"
                                                                                value={value != null ? value : ""}
                                                                                    onChange={(f) => {
                                                                                        changeSelectedCultureTypeRow(f.target.value, sskpi, row, op)
                                                                                    }}
                                                                                />
                                                                            </>

                                                                        }
                                                                        {
                                                                            sskpi.mandatory == true &&
                                                                            <div class="required-icon">
                                                                                <div class="text">*</div>
                                                                            </div>
                                                                        }
                                                                    </Field>
                                                                </OverlayTrigger>
                                                            </>
                                                            :
                                                            sskpi.unitMeasure.type === "selectCuringBarn" ?
                                                                <>
                                                                    {loadRefNumbersAndCalculations(sskpi)}
                                                                    <TooltipAlertComponent id={`${op}_alert`} message={sskpi.alertMessage} className={`alert-column ${findValue?.toleranceInvalid ? '' : 'hide'}`} placement={"left"} />
                                                                    <OverlayTrigger
                                                                        delay={{ hide: 0, show: 100 }}
                                                                        overlay={(props) => (
                                                                            (value != null || sskpi.inputMessage != null) ? //validate overlay when field is text on Prompt Actions Modules
                                                                                <Tooltip {...props}>
                                                                                    {(value != null ? selectedCuringBarns.find(x => x.index == row && x.subSectionID == sskpi.subSectionID)?.text : (sskpi.inputMessage ? sskpi.inputMessage : ""))}
                                                                                </Tooltip>

                                                                                :
                                                                                <></>
                                                                        )}
                                                                        placement={"left"}>
                                                                        <Field>
                                                                            {moduleObject.curingBarnsOptions.length > 0 &&
                                                                                <>
                                                                                    <FormInput
                                                                                        disabled={disabledField}
                                                                                        blockedValueAlert={shouldShowBlockedAlert}
                                                                                        options={moduleObject.curingBarnsOptions.filter(x => x.kpiRefNumber == sskpi.refNumber)}
                                                                                        name={op}
                                                                                        id={op}
                                                                                        inputType={sskpi.unitMeasure.type}
                                                                                        autoComplete="off"
                                                                                        value={value != null ? value : ""}
                                                                                        onChange={(f) => {
                                                                                            changeSelectedCuringBarn(f.target.value, sskpi, row, op)
                                                                                        }}
                                                                                    />
                                                                                </>

                                                                            }
                                                                            {
                                                                                sskpi.mandatory == true &&
                                                                                <div class="required-icon">
                                                                                    <div class="text">*</div>
                                                                                </div>
                                                                            }
                                                                        </Field>
                                                                    </OverlayTrigger>
                                                                </>
                                                                :
                                                                sskpi.unitMeasure.type === "fuelTypeUnit" ?
                                                                    <>
                                                                        {loadRefNumbersAndCalculations(sskpi)}
                                                                        <TooltipAlertComponent id={`${op}_alert`} message={sskpi.alertMessage} className={`alert-column ${findValue?.toleranceInvalid ? '' : 'hide'}`} placement={"left"} />
                                                                        <OverlayTrigger
                                                                            delay={{ hide: 0, show: 100 }}
                                                                            overlay={(props) => (
                                                                                (value != null || sskpi.inputMessage != null) ? //validate overlay when field is text on Prompt Actions Modules
                                                                                    <Tooltip {...props}>
                                                                                        {(value != null ? selectedFuelTypes.find(x => x.index == row && x.subSectionID == sskpi.subSectionID)?.unit : (sskpi.inputMessage ? sskpi.inputMessage : ""))}
                                                                                    </Tooltip>

                                                                                    :
                                                                                    <></>
                                                                            )}
                                                                            placement={"left"}>
                                                                            <Field>
                                                                                {moduleObject.fuelTypesOptions.length > 0 &&
                                                                                    <>
                                                                                        <input
                                                                                            disabled={disabledField}
                                                                                            className={`${findValue?.toleranceInvalid ? 'alert-input ' : ''}read-only-total`}
                                                                                            name={op}
                                                                                            id={op}
                                                                                            inputType={sskpi.unitMeasure.type}
                                                                                            autoComplete="off"
                                                                                            value={value != null ? value : ""}
                                                                                            onChange={(f) => {
                                                                                                setText({
                                                                                                    'subSectionKPI': sskpi,
                                                                                                    'ref': sskpi.refNumber,
                                                                                                    'value': f.target.value,
                                                                                                    'row': row,
                                                                                                    'fuelTypeID': selectedFuelTypes[row]?.value,
                                                                                                    'moduleObject': moduleObject,
                                                                                                    'setModuleObject': setModuleObject,
                                                                                                    'subSectionKPIs': subSectionKPIs
                                                                                                })
                                                                                            }}
                                                                                        />
                                                                                    </>

                                                                                }
                                                                                {
                                                                                    sskpi.mandatory == true &&
                                                                                    <div class="required-icon">
                                                                                        <div class="text">*</div>
                                                                                    </div>
                                                                                }
                                                                            </Field>
                                                                        </OverlayTrigger>
                                                                    </>
                                                                    :
                                                                    sskpi.unitMeasure.type === "selectcountry" ?
                                                                        <>
                                                                            {loadRefNumbersAndCalculations(sskpi)}
                                                                            <TooltipAlertComponent id={`${op}_alert`} message={sskpi.alertMessage} className={`alert-column ${findValue?.toleranceInvalid ? '' : 'hide'}`} placement={"left"} />
                                                                            <OverlayTrigger
                                                                                delay={{ hide: 0, show: 100 }}
                                                                                overlay={(props) => (
                                                                                    (value != null || sskpi.inputMessage != null) ? //validate overlay when field is text on Prompt Actions Modules
                                                                                        <Tooltip {...props}>
                                                                                            {(value != null ? value : sskpi.inputMessage ? sskpi.inputMessage : "")}
                                                                                        </Tooltip>

                                                                                        :
                                                                                        <></>
                                                                                )}
                                                                                placement={"left"}>
                                                                                <Field>
                                                                                    {moduleObject.countriesOptions.length > 0 &&
                                                                                        <>
                                                                                            <FormInput
                                                                                                disabled={disabledField}
                                                                                                className={findValue?.toleranceInvalid ? 'alert-input' : ''}
                                                                                                blockedValueAlert={shouldShowBlockedAlert}
                                                                                                options={moduleObject.countriesOptions}
                                                                                                name={op}
                                                                                                id={op}
                                                                                                inputType={sskpi.unitMeasure.type}
                                                                                                autoComplete="off"
                                                                                                value={value != null ? value : ""}
                                                                                                onChange={(f) => {
                                                                                                    changeSelectedCountry(f.target.value, sskpi, row)
                                                                                                }}
                                                                                            />
                                                                                        </>

                                                                                    }
                                                                                    {
                                                                                        sskpi.mandatory == true &&
                                                                                        <div class="required-icon">
                                                                                            <div class="text">*</div>
                                                                                        </div>
                                                                                    }
                                                                                </Field>
                                                                            </OverlayTrigger>
                                                                        </>
                                                                        :
                                                                        sskpi.unitMeasure.inputType == "input" || sskpi.unitMeasure.inputType == "" || sskpi.unitMeasure.inputType == null ?
                                                                            <>
                                                                                {loadRefNumbersAndCalculations(sskpi)}
                                                                                <OverlayTrigger
                                                                                    delay={{ hide: 0, show: 100 }}
                                                                                    overlay={(props) => (
                                                                                        (value != null || sskpi.inputMessage != null) ? //validate overlay when field is text on Prompt Actions Modules
                                                                                            <Tooltip {...props}>
                                                                                                {(value != null ? value : sskpi.inputMessage ? sskpi.inputMessage : "")}
                                                                                            </Tooltip>

                                                                                            :
                                                                                            <></>
                                                                                    )}
                                                                                    placement={"left"}>
                                                                                    <Field>
                                                                                        <input
                                                                                            name={op}
                                                                                            id={op}
                                                                                            autoComplete="off"
                                                                                            style={isFromFSMIntegration == true ? { border: "2px solid #50af47" } : highlightField ? { border: "2px solid #FBBA00" } : highLightBorderColor ? { border: `2px solid ${sskpi.borderColor}` } : {}}
                                                                                            value={value != null ? value : ""}
                                                                                            title={moduleObject.isEditable && value != null ? sskpi.inputMessage : ""}
                                                                                            type={"text"}
                                                                                            className={`${findValue?.toleranceInvalid ? 'alert-input ' : ''}${isDisplayText ? "read-only-total" : ""}`}
                                                                                            disabled={moduleObject.isEditable ? blockedField ? true : disabledField : true}
                                                                                            onChange={(f) => {
                                                                                                if (!loading) {
                                                                                                    setText({
                                                                                                        'subSectionKPI': sskpi,
                                                                                                        'ref': sskpi.refNumber,
                                                                                                        'value': f.target.value,
                                                                                                        'row': row,
                                                                                                        'moduleObject': moduleObject,
                                                                                                        'setModuleObject': setModuleObject,
                                                                                                        'subSectionKPIs': subSectionKPIs
                                                                                                    })
                                                                                                }

                                                                                            }
                                                                                            }
                                                                                        />
                                                                                        {
                                                                                            sskpi.mandatory == true &&
                                                                                            <div class="required-icon">
                                                                                                <div class="text">*</div>
                                                                                            </div>
                                                                                        }
                                                                                    </Field>
                                                                                </OverlayTrigger>
                                                                            </>
                                                                            :
                                                                            <>
                                                                                {loadRefNumbersAndCalculations(sskpi)}
                                                                                <OverlayTrigger
                                                                                    delay={{ hide: 0, show: 100 }}
                                                                                    overlay={(props) => (
                                                                                        (value != null || sskpi.inputMessage != null) ?
                                                                                            <Tooltip {...props}>
                                                                                                {(value != null ? value : sskpi.inputMessage ? sskpi.inputMessage : "")}
                                                                                            </Tooltip>

                                                                                            :
                                                                                            <></>
                                                                                    )}
                                                                                    placement={"left"}>
                                                                                    <Field>
                                                                                        <FormInput
                                                                                            name={op}
                                                                                            id={op}
                                                                                            autoComplete="off"
                                                                                            value={value != null ? value : ""}
                                                                                            className={`${findValue?.toleranceInvalid ? 'alert-input ' : ''}${shouldShowBlockedAlert ? 'alert-input-hasValue ' : ''}${kpi.kpiDescription}`}
                                                                                            blockedValueAlert={shouldShowBlockedAlert}
                                                                                            style={{
                                                                                                ...(highlightField ? { border: "2px solid #FBBA00" } : highLightBorderColor ? { border: `2px solid ${sskpi.borderColor}` } : {}),
                                                                                            }}
                                                                                            inputType={sskpi.unitMeasure.inputType != null && sskpi.unitMeasure.inputType != "" ? sskpi.unitMeasure.inputType : "text"}
                                                                                            placeholder={sskpi.unitMeasure.inputType == "selectcustom" ? { value: "", text: "Select an option" } : null}
                                                                                            customOptions={sskpi.customOptions}
                                                                                            disabled={disabledField}
                                                                                            checked={sskpi.unitMeasure.inputType == "radio" ? (value === "true") ? true : null : null}
                                                                                            onChange={(f) => {
                                                                                                setText({
                                                                                                    'subSectionKPI': sskpi,
                                                                                                    'ref': sskpi.refNumber,
                                                                                                    'value': f.target.value,
                                                                                                    'row': row,
                                                                                                    'moduleObject': moduleObject,
                                                                                                    'setModuleObject': setModuleObject,
                                                                                                    'subSectionKPIs': subSectionKPIs
                                                                                                })
                                                                                            }
                                                                                            }
                                                                                        />
                                                                                        {
                                                                                            sskpi.mandatory == true &&
                                                                                            <div class="required-icon">
                                                                                                <div class="text">*</div>
                                                                                            </div>
                                                                                        }
                                                                                    </Field>
                                                                                </OverlayTrigger>
                                                                            </>
                                            :
                                            sskpi.listTreeID && sskpi.optionsModeView > 0 ?
                                                <>
                                                    {loadRefNumbersAndCalculations(sskpi)}
                                                    <Field>
                                                        <FormInput
                                                            name={op}
                                                            id={op}
                                                            inputType="listtreeselect"
                                                            listTreeID={sskpi.listTreeID}
                                                            optionsModeView={sskpi.optionsModeView}
                                                            allowSelectOnlyChildrenNodes={sskpi.allowSelectOnlyChildrenNodes}
                                                            maxTreeDepth={sskpi.maxTreeDepth}
                                                            parentItemIDsFilter={parentItemIDsFilter}
                                                            value={value != null ? value : ''}
                                                            disabled={true}
                                                            onChange={() => {}}
                                                        />
                                                    </Field>
                                                </>
                                            :
                                            sskpi.unitMeasure.type === 'Selection from kpi' && sskpi.selectAnswersRefNumber ?
                                                <SelectionFromKpiSelectField
                                                    sskpi={sskpi}
                                                    refSubSectionKPI={subSectionKPIs.find(x => x.refNumber === sskpi.selectAnswersRefNumber)}
                                                    fallbackOptions={SSKReferenceAnswersOptionsList}
                                                    numberOfRows={numberOfRows}
                                                    row={row}
                                                    numberOfColumns={1}
                                                    column={null}
                                                    moduleObject={moduleObject}
                                                    op={op}
                                                    value={value}
                                                    disabledField={disabledField}
                                                    loading={loading}
                                                    setText={setText}
                                                    subSectionKPIs={subSectionKPIs}
                                                    findValue={findValue}
                                                    loadRefNumbersAndCalculations={loadRefNumbersAndCalculations}
                                                    cultureTypeID={cultureTypeID}
                                                    readOnly={true}
                                                />
                                            :
                                            sskpi.unitMeasure.inputType == "textarea" ?
                                                <>
                                                    {loadRefNumbersAndCalculations(sskpi)}
                                                    <OverlayTrigger
                                                        delay={{ hide: 0, show: 100 }}
                                                        overlay={(props) => (
                                                            (value != null || sskpi.inputMessage != null) ?
                                                                <Tooltip {...props}>
                                                                    {(value != null ? value : sskpi.inputMessage ? sskpi.inputMessage : "")}
                                                                </Tooltip>

                                                                :
                                                                <></>
                                                        )}
                                                        placement={"left"}>
                                                        <textarea
                                                            name={`kpiColumnRowID_${sskpi.kpiColumnRowID}_${row}`}
                                                            id={`kpiColumnRowID_${sskpi.kpiColumnRowID}_${row}`}
                                                            autoComplete="off"
                                                            style={{ width: '100%', background: 'none', border: 0, resize: 'none', verticalAlign: 'middle' }}
                                                            value={value != null ? value : ""}
                                                            className="read-only text-center"
                                                            disabled={disabledField}
                                                            rows="2"

                                                        />
                                                    </OverlayTrigger>
                                                </>
                                                :
                                                isNumber ?
                                                    <>
                                                        {loadRefNumbersAndCalculations(sskpi)}
                                                        <OverlayTrigger
                                                            delay={{ hide: 0, show: 100 }}
                                                            overlay={(props) => (
                                                                (value != null || sskpi.inputMessage != null) ?
                                                                    <Tooltip {...props}>
                                                                        {(value != null ? value : sskpi.inputMessage ? sskpi.inputMessage : "")}
                                                                    </Tooltip>

                                                                    :
                                                                    <></>
                                                            )}
                                                            placement={"left"}>
                                                            <div className='text-center'>
                                                                {formatValuesInTooltip(value, unitMeasure.decimalSeparator, unitMeasure.decimalPrecision, unitMeasure.suffix, moduleObject.isEditable, isCalculation, highlightField, highLightBorderColor, sskpi.borderColor)}
                                                            </div>
                                                        </OverlayTrigger>
                                                    </>
                                                    :
                                                    (sskpi.unitMeasure.inputType === "" || sskpi.unitMeasure.inputType === "text" ?
                                                        <>
                                                            {loadRefNumbersAndCalculations(sskpi)}
                                                            <OverlayTrigger
                                                                delay={{ hide: 0, show: 100 }}
                                                                overlay={(props) => (
                                                                    (value != null || sskpi.inputMessage != null) ?
                                                                        <Tooltip {...props}>
                                                                            {(value != null ? value : sskpi.inputMessage ? sskpi.inputMessage : "")}
                                                                        </Tooltip>

                                                                        :
                                                                        <></>
                                                                )}
                                                                placement={"left"}>

                                                                <textarea
                                                                    name={op}
                                                                    id={op}
                                                                    autoComplete="off"
                                                                    style={isFromFSMIntegration == true ? { border: "2px solid #50af47" } : highlightField ? { border: "2px solid #FBBA00" } : highLightBorderColor ? { border: `2px solid ${sskpi.borderColor}` } : {}}
                                                                    value={value != null ? value : ""}
                                                                    title={moduleObject.isEditable ? sskpi.inputMessage : ""}
                                                                    inputType={"text"}
                                                                    className={(isNumber && isCalculation) || isDisplayText ? "read-only-total" : "read-only"}
                                                                    disabled={moduleObject.isEditable ? false : true}

                                                                />
                                                            </OverlayTrigger>
                                                        </>
                                                        :
                                                        <>
                                                            {loadRefNumbersAndCalculations(sskpi)}
                                                            <OverlayTrigger
                                                                delay={{ hide: 0, show: 100 }}
                                                                overlay={(props) => (
                                                                    (value != null || sskpi.inputMessage != null) ?
                                                                        <Tooltip {...props}>
                                                                            {(value != null ? value : sskpi.inputMessage ? sskpi.inputMessage : "")}
                                                                        </Tooltip>

                                                                        :
                                                                        <></>
                                                                )}
                                                                placement={"left"}>

                                                                <input
                                                                    name={op}
                                                                    id={op}
                                                                    autoComplete="off"
                                                                    style={isFromFSMIntegration == true ? { border: "2px solid #50af47" } : highlightField ? { border: "2px solid #FBBA00" } : highLightBorderColor ? { border: `2px solid ${sskpi.borderColor}` } : {}}
                                                                    value={value != null ? value : ""}
                                                                    title={moduleObject.isEditable ? sskpi.inputMessage : ""}
                                                                    inputType={"text"}
                                                                    className={(isNumber && isCalculation) || isDisplayText ? "read-only-total" : "read-only"}
                                                                    disabled={moduleObject.isEditable ? false : true}

                                                                />
                                                            </OverlayTrigger>
                                                        </>
                                                    )


                                    }
                                </div>
                                <div
                                    className={isWideRowModeCell ? 'col-1' : 'col-2'}
                                    style={{ paddingTop: 0, paddingLeft: 0 }}
                                >

                                    {hasDiscussion ?
                                        <a style={{ marginLeft: "0.25rem", pointerEvents: "none" }}>
                                            <MdChat color={discussionCollor != "" ? discussionCollor : "#fff"}>
                                            </MdChat>
                                            {IconDiscussionToAnswer(hasDiscussion)}
                                        </a>
                                        :
                                        <></>
                                    }

                                    <a id={op + "_comment"} name={op + "_comment"} onClick={() => collapseByRow(sskpi, op, row)}>
                                        {collapse == (sskpi.subSectionKPIID) && collapseRow == row ?
                                            <FaAngleUp size={20} color={
                                                (comment != "" && comment != null) || (file != "" && file != null) ?
                                                    "green"
                                                    :
                                                    (sskpi.comment == "Mandatory" || sskpi.evidence == "Mandatory" || (sskpi.mandatoryAttachment && (value == null || value === '' || Number(value) !== 0))) && !disabledField ?
                                                        "red"
                                                        :
                                                        ""
                                            } />
                                            :
                                            <FaAngleDown size={20} color={
                                                (comment != "" && comment != null) || (file != "" && file != null) ?
                                                    "green"
                                                    :
                                                    (sskpi.comment == "Mandatory" || sskpi.evidence == "Mandatory" || (sskpi.mandatoryAttachment && (value == null || value === '' || Number(value) !== 0))) && !disabledField ?
                                                        "red"
                                                        :
                                                        ""
                                            } />
                                        }
                                    </a>
                                </div>
                            </div>
                        </td >
                    </>
                }
                else {
                    return <>
                        <td 
                            key={`subSectionKPI_td`} 
                            colSpan={1}
                            style={{
                                minWidth: '120px',
                                width: getRowModeValueTdWidthStyle(null, subSectionKPIs, rowValueColumnLayout),
                            }}
                        >
                        </td>
                    </>
                }
            })
        }

    </>
}

export default RowSimpleGrouped;

